import MoreDots from '../../src/legacy/MoreDots';
export default MoreDots;
